import { Component, OnInit } from '@angular/core';
import { KursService } from '../_services/kurs.service';
import { Kurs } from '../_models/kurs';

@Component({
  selector: 'app-classmgmt',
  templateUrl: './classmgmt.component.html',
  styles: []
})
export class ClassmgmtComponent implements OnInit {

  constructor(private kursService:KursService) { }

  sites: string[] = this.kursService.standorte;
  classes: Kurs[];

  ngOnInit() {
    this.kursService.getKurse().subscribe(
      x => this.classes = x,
      err => { console.log("error loading classes:"); console.log(err); },
      () => { }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/_components/classmgmt.component.ts